import * as React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { useCustomTheme } from "../context/ThemeContext";

export default function Evento(props) {
  const { themeSettings } = useCustomTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        margin: "auto",
        maxWidth: 500,
        flexGrow: 1,
        backgroundColor: themeSettings?.news_card_bg || "#F7E951",
        borderRadius: "24px", // Leggermente meno arrotondato, più moderno
        textAlign: { xs: "center", sm: "left" }, // Testo centrato su mobile, a sinistra su desktop
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* Colonna Data e Ora - Raggruppate con Stack */}
        <Grid item xs={12} sm={4}>
          <Stack>
            <Typography variant="h6" component="p" sx={{ fontWeight: 'bold' }}>
              {props.date}
            </Typography>
            <Typography variant="subtitle1" component="p" color="text.secondary">
              {props.time}
            </Typography>
          </Stack>
        </Grid>

        {/* Colonna Titolo e Testo */}
        <Grid item xs={12} sm={8}>
          <Typography gutterBottom variant="h6" component="div">
            {props.title}
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{props.text}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}